// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DrawerOpenerController from "./drawer_opener_controller"
application.register("drawer-opener", DrawerOpenerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FullcalendarMovementsController from "./fullcalendar_movements_controller"
application.register("fullcalendar-movements", FullcalendarMovementsController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import RowClickController from "./row_click_controller"
application.register("row-click", RowClickController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import ToggleFieldsController from "./toggle_fields_controller"
application.register("toggle-fields", ToggleFieldsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UploadedFilesController from "./uploaded_files_controller"
application.register("uploaded-files", UploadedFilesController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)
